module.exports = __webpack_public_path__ + "static/img/p1.7481361.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/robot/LM1/p1.png
// module id = S9jh
// module chunks = 7